<template>
    <div
        class="row"
    >
        <h1>{{ project.name }}</h1>

        <q-btn
            @click="deleteLimbCache"
            icon="sync"
            class="hover-primary q-ml-sm"
            :loading="limbCacheIsDeleting"
            flat
            round
        >
            <q-tooltip
                :delay="500"
                :offset="[0, 5]"
            >
                Сбросить кэш проекта
            </q-tooltip>
        </q-btn>


        <q-btn
            @click="updateCompanyInfo"
            icon="info"
            class="hover-primary q-ml-sm"
            :loading="updatingCompanyInfo"
            flat
            round
            :disabled="updatingCompanyInfo"
        >
            <q-tooltip
                :delay="500"
                :offset="[0, 5]"
            >
                Обновить данные про компанию в Intercom
            </q-tooltip>
        </q-btn>
    </div>
</template>

<script>
import {QBtn, QTooltip} from 'quasar'

export default {
    name: 'ProjectHeader',

    props: {
        project: {
            type: Object,
            required: true,
        },
    },

    components: {
        QBtn,
        QTooltip,
    },

    data () {
        return {
            modalOpened: false,
            limbCacheIsDeleting: false,
            updatingCompanyInfo: false,
        }
    },

    methods: {
        deleteLimbCache () {
            this.limbCacheIsDeleting = true

            this.$store.dispatch('project/deleteLimbCache', this.project).then(() => {
                this.$q.notify({
                    message: `Запрос на сброс кэша успешно отправлен`,
                    type: 'positive',
                    position: 'bottom',
                })

                this.limbCacheIsDeleting = false
            }).catch(e => {
                this.$q.notify({
                    message: `${e.message}`,
                    type: 'negative',
                    position: 'bottom',
                })

                this.limbCacheIsDeleting = false
            })
        },


        updateCompanyInfo () {
            this.updatingCompanyInfo = true

            this.$store.dispatch('project/updateCompanyInfo', this.project).then(() => {
                this.$q.notify({
                    message: `Запрос на обновление информации поставлен в очередь`,
                    type: 'positive',
                    position: 'bottom',
                })
            }).catch(e => {
                this.$q.notify({
                    message: `${e.message}`,
                    type: 'negative',
                    position: 'bottom',
                })
            }).finally(() => {
                this.updatingCompanyInfo = false
            })
        },
    },
}
</script>

<style scoped>
.q-btn {
    margin-top: -8px;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/ProjectHeader/ProjectHeader.vue